var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VAlert',{attrs:{"color":"warning"}},[_vm._v(_vm._s(_vm.$t('noIntegrations')))])}
var staticRenderFns = []

export { render, staticRenderFns }